import { SelectedAge } from "../../models/SelectedAge";

export function getRightAge(selectedAge : SelectedAge, customAge:number=0): number{
    if(customAge!==0){
        return customAge
    }
    else{
    switch(selectedAge){
        case SelectedAge.birth :{
            return 0
        }
        case SelectedAge.sixtyFive:{
            return 65
        }
        default:{
        return customAge
        }
      }
    }
}